/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { LieuFormationGridDto } from './LieuFormationGridDto';
import {
    LieuFormationGridDtoFromJSON,
    LieuFormationGridDtoFromJSONTyped,
    LieuFormationGridDtoToJSON,
} from './LieuFormationGridDto';

/**
 * 
 * @export
 * @interface LieuFormationGridDtoPaginatedResults
 */
export interface LieuFormationGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof LieuFormationGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<LieuFormationGridDto>}
     * @memberof LieuFormationGridDtoPaginatedResults
     */
    results?: Array<LieuFormationGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof LieuFormationGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the LieuFormationGridDtoPaginatedResults interface.
 */
export function instanceOfLieuFormationGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LieuFormationGridDtoPaginatedResultsFromJSON(json: any): LieuFormationGridDtoPaginatedResults {
    return LieuFormationGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function LieuFormationGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LieuFormationGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(LieuFormationGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function LieuFormationGridDtoPaginatedResultsToJSON(value?: LieuFormationGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(LieuFormationGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

